import { Box, CloseButton, Drawer, Title } from "@dehub/theme";
import { useTranslation } from "react-i18next";
import useSWR from "swr";
import { BranchApi } from "@/apis";
import { WarehouseForm } from "@/features/warehouse/components/forms/warehouse-form";
import type { WarehousePermissions } from "../hooks/useWarehousePermissions";
import classes from "../warehouse.module.css";

type Props = Readonly<{
  opened: boolean;
  perms: WarehousePermissions;
  onClose: () => void;
  onReload: () => void;
}>;

/** "Add warehouse" drawer (720px, theme overlay and shadow). Editing and viewing are on the detail page. */
export function WarehouseDrawer({ opened, perms, onClose, onReload }: Props) {
  const { t } = useTranslation("warehouse");
  const { t: tCommon } = useTranslation("common");

  const { data: branches } = useSWR(
    opened ? "/branch" : null,
    () => BranchApi.list({ filter: { query: "" }, offset: { page: 1, limit: 100 } }),
    { revalidateOnFocus: false },
  );

  return (
    <Drawer position="right" opened={opened} onClose={onClose} withCloseButton={false} size={720} padding={0}>
      <Box className={classes.drawerHead}>
        <Title order={2} className={classes.drawerTitle}>
          {t("addTitle")}
        </Title>
        <CloseButton size={32} onClick={onClose} aria-label={tCommon("actions.close")} />
      </Box>
      <Box className={classes.drawerBody}>
        {perms.add.hasAccess ? (
          <WarehouseForm branches={branches} reload={onReload} onClose={onClose} />
        ) : (
          perms.add.accessDenied()
        )}
      </Box>
    </Drawer>
  );
}
